import { useIsSmartFillSellerSettingEnabled } from '../use-seller-setting';

export const useIsSmartFillEnabledForSeller = () => {
  const isSellerSettingTurnedOn = useIsSmartFillSellerSettingEnabled();
  return isSellerSettingTurnedOn;
};
